/**
 * Constants of coordinates.
 * Ported from Java by Mark Movshovich
 */
export class Consts
{
	/**
	 * Major Axis of Earth Ellipsoid.
	 */
	public static MAJOR_AXIS: number;

	/**
	 * Minor Axis of Earth Ellipsoid.
	 */
	public static MINOR_AXIS: number;

	/**
	 * Radius of Earth at the latitude of UVH origin, WGS84 projection system
	 * [meters].
	 */
	public static EARTH_RADIUS: number;

	/**
	 * The Origin of UVH Coordinates System (ITCS) in Geo (GCS), The Lat
	 * Coordinate.
	 */
	public static _LAT_ORIGIN: number;

	/**
	 * The Origin of UVH Coordinates System (ITCS) in Geo (GCS), The Lon
	 * Coordinate.
	 */
	public static _LON_ORIGIN: number;

	/**
	 * Toms region 1 constant.
	 */
	public static AD_C: number;

	static initialize() {
		let latOriginDeg = 32.002;
		let lonOriginDeg = 34.8;
		let earthRadius = 6372167.3949025022;
		let adc = 1.0026000;
		let majorAxis = 6378137.0;
		let minorAxis = 6356752.314245179;

    // Can be overriden by some parameters file
    
    const DegreesToRadians: number = Math.PI / 180.0;

    this._LAT_ORIGIN = latOriginDeg * DegreesToRadians;
    this._LON_ORIGIN = lonOriginDeg * DegreesToRadians;
    this.EARTH_RADIUS = earthRadius;
    this.AD_C = adc;
    this.MAJOR_AXIS = majorAxis; // WGS84
    this.MINOR_AXIS = minorAxis; // WGS84
	}

  // Prevent object creation
  private constructor() {}
}

Consts.initialize();
